import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { forkJoin, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { Producto } from "../models/Producto/Producto";
import { Servicio } from "../models/Servicio/Servicio";
import { PagedResponse } from "../shared/models/PagedResponse";
import { environment } from "src/environments/environment";

export interface ResultadoCatalogo {
	id: string;
	nombre: string;
	codigo: string;
	tipo: "Producto" | "Servicio";
	producto?: Producto;
	servicio?: Servicio;
}

@Injectable({ providedIn: "root" })
export class BuscadorCatalogoService {
	constructor(private http: HttpClient) {}

	buscar(termino: string, emisorId: string, sucursalId: string): Observable<ResultadoCatalogo[]> {
		const texto = termino.trim();
		if (!texto || !emisorId || !sucursalId) return of([]);
		const params = new HttpParams()
			.set("EmisorId", emisorId).set("SucursalId", sucursalId)
			.set("activo", "1").set("pageNumber", "1").set("pageSize", "20");
		return forkJoin([
			this.http.get<PagedResponse<Producto>>(environment.backend_server + "/producto/list/filter", { params: params.set("nombre", texto) }),
			this.http.get<PagedResponse<Producto>>(environment.backend_server + "/producto/list/filter", { params: params.set("codigoBarra", texto) }),
			this.http.get<PagedResponse<Servicio>>(environment.backend_server + "/servicio/list/filter", { params: params.set("nombre", texto) }),
		]).pipe(map(([porNombre, porCodigo, servicios]) => {
			const productos = new Map<string, Producto>();
			[...(porNombre.data || []), ...(porCodigo.data || [])].forEach(producto => productos.set(producto.productoId, producto));
			return [
				...Array.from(productos.values()).map(producto => ({
					id: "producto-" + producto.productoId, nombre: producto.nombre,
					codigo: producto.codigoBarra || "", tipo: "Producto" as const, producto,
				})),
				...(servicios.data || []).map(servicio => ({
					id: "servicio-" + servicio.servicioId, nombre: servicio.nombre,
					codigo: "", tipo: "Servicio" as const, servicio,
				})),
			];
		}));
	}
}
